import React, { Fragment, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  faCheck,
  faEnvelope,
  faEye,
  faQuestion,
  faUsers,
  faTrash,
  faReply,
  faExclamationCircle } from
"@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import CreateMessage from "../StudentMessage/CreateMessage";
import CannedModal from "../StudentMessage/CannedModal";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import "./GroupMessage.css";

const GroupMessage = () => {
  let location = useLocation();
  let history = useHistory();
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );

  // Function to convert URLs in text to clickable links
  const renderMessageWithLinks = (text) => {
    if (!text) return "";

    // Regular expression to detect URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Split text by URLs and create an array of text and link elements
    const parts = text.split(urlRegex);

    return (
      <div
        style={{
          textAlign: "justify",
          wordWrap: "break-word",
          overflowWrap: "break-word"
        }}>

        {parts.map((part, index) => {
          if (urlRegex.test(part)) {
            return (
              <div key={index} style={{ margin: "5px 0" }}>
                <a
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#007bff",
                    textDecoration: "underline",
                    wordBreak: "break-all",
                    display: "block",
                    lineHeight: "1.4",
                    padding: "2px 0"
                  }}>

                  {part}
                </a>
              </div>);

          }
          // Split by line breaks and render them properly
          return part.split("\n").map((line, lineIndex, array) =>
          <span key={`${index}-${lineIndex}`}>
              {line}
              {lineIndex < array.length - 1 && <br />}
            </span>
          );
        })}
      </div>);

  };

  const getGroupNames = (item) => {
    try {
      const groups = JSON.parse(item?.groups?.replace(/'/g, '"'));
      return [...new Set(Object.values(groups).map((g) => g?.name).filter(Boolean))];
    } catch (_) {
      return [];
    }
  };

  const [page] = useState(1);
  const [groupMessageDetails, setGroupMessageDetails] = useState([]);
  const [selectedGroupMessageValue, setSelectedGroupMessageValue] = useState();
  const [showSingleMessage, setShowSingleMessage] = useState(false);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(-1);
  const [openCreateGroupMessage, setOpenCreateGroupMessage] = useState(
    location?.state?.openCreateGroupMessage ?
    location?.state?.openCreateGroupMessage :
    false
  );

  const [openCannedModal, setOpenedCannedModal] = useState(false);
  const [
  messageValueForCreateMessage,
  setMessageValueForCreateMessage] =
  useState();

  const getGroupMessageDetails = () => {
    let obj = {
      counselor_id: user?.counselor_id,
      page: page,
      school_id: user?.school_id
    };
    GetStudentService.getMessageForGroupInIT(obj)
    .then((data) => {
      setGroupMessageDetails(data?.data?.result);
    })
    .catch(() => {});
  };

  const deleteGroupMessage = (value) => {
    let obj = {
      id: value?.id,
      type: "group"
      // type: "group_message",
    };
    GetStudentService.deleteMessageForStudent(obj)
    .then((_data) => {
      getGroupMessageDetails();
      setShowSingleMessage(false);
      setSelectedGroupMessageValue();
    })
    .catch(() => {});
  };

  const handleGroupMessageSelect = (value, index) => {
    setSelectedGroupMessageValue(value);
    setShowSingleMessage(true);
    setSelectedGroupIndex(index);
  };

  const createGroupMessageHandler = () => {
    setOpenCreateGroupMessage(true);
  };

  const handleCannedMessageSelect = (value) => {
    setMessageValueForCreateMessage(value?.messages?.en?.body);
    setOpenedCannedModal(false);
  };

  useEffect(() => {
    getGroupMessageDetails();
  }, []);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="group-message-page">
            <div className="group-message-header">
              <div>
                <h1 className="group-message-title">Group Messages</h1>
                <p className="group-message-subtitle">
                  Create and review messages sent to student groups
                </p>
              </div>
              <div className="group-message-actions">
                <button
                  type="button"
                  onClick={() => {
                    history.push({
                      pathname: "/school_it/maintain_group",
                      state: { openGroupMessage: true }
                    });
                  }}
                  className="group-message-btn">

                  <FontAwesomeIcon icon={faUsers} />
                  Create Group
                </button>
                <button
                  type="button"
                  className="group-message-btn secondary"
                  onClick={createGroupMessageHandler}>

                  <FontAwesomeIcon icon={faUsers} />
                  Create Group Message
                </button>
              </div>
            </div>

            <div className="group-message-layout">
              <div className="group-message-list-panel">
                {groupMessageDetails?.length > 0 ?
                groupMessageDetails.map((item, index) => {
                  const names = getGroupNames(item);
                  const visible = names.slice(0, 3);
                  const more = Math.max(0, names.length - 3);
                  return (
                    <div
                      key={item?.id || index}
                      className={`group-message-item ${
                      index === selectedGroupIndex ? "is-active" : ""
                      }`}
                      onClick={() => handleGroupMessageSelect(item, index)}>

                        {item?.priority === "critical" &&
                      <div className="group-message-critical">
                            <FontAwesomeIcon icon={faExclamationCircle} />
                          </div>}

                        <div className="group-message-item-top">
                          <div
                          className="group-message-chips"
                          title={names.join(", ") || "Group"}>

                            {visible.length > 0 ?
                          visible.map((name) =>
                          <span key={name} className="group-message-chip">
                                  {name}
                                </span>
                          ) :

                          <span className="group-message-chip">Group</span>}

                            {more > 0 &&
                          <span className="group-message-chip more">
                                +{more} more
                              </span>}

                          </div>
                          <div className="group-message-item-meta">
                            <p className="group-message-time">
                              {moment(item?.date_sent).format(
                              "ddd DD MMM YYYY, HH:mm A"
                            )}
                            </p>
                            <button
                            type="button"
                            className="group-message-delete"
                            title="Delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteGroupMessage(item);
                            }}>

                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        </div>
                        <p className="group-message-subject">{item?.subject}</p>
                        <div className="group-message-counts">
                          <span>
                            <FontAwesomeIcon icon={faEnvelope} />
                            {item?.count_messages}
                          </span>
                          <span>
                            <FontAwesomeIcon icon={faEye} />
                            {item?.count_opened}
                          </span>
                          <span>
                            <FontAwesomeIcon icon={faCheck} />
                            {item?.count_ack}
                          </span>
                          <span>
                            <FontAwesomeIcon icon={faQuestion} />
                            {item?.count_feedback}
                          </span>
                        </div>
                      </div>);

                }) :

                <div className="group-message-empty">
                    No group messages yet
                  </div>}

              </div>

              <div className="group-message-detail-panel">
                {showSingleMessage && selectedGroupMessageValue ?
                <>
                    <div
                    className="group-message-chips"
                    title={getGroupNames(selectedGroupMessageValue).join(", ")}>

                      {(() => {
                      const names = getGroupNames(selectedGroupMessageValue);
                      const visible = names.slice(0, 4);
                      const more = Math.max(0, names.length - 4);
                      if (!visible.length) {
                        return (
                          <span className="group-message-chip">Group</span>);

                      }
                      return (
                        <>
                            {visible.map((name) =>
                          <span key={name} className="group-message-chip">
                                {name}
                              </span>
                          )}
                            {more > 0 &&
                          <span className="group-message-chip more">
                                +{more} more
                              </span>}

                          </>);

                    })()}
                    </div>
                    <p className="group-message-detail-subject">
                      {selectedGroupMessageValue?.subject}
                    </p>
                    <div className="group-message-detail-body">
                      {renderMessageWithLinks(selectedGroupMessageValue?.body)}
                    </div>
                    {selectedGroupMessageValue?.attachment_url !== null &&
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={selectedGroupMessageValue?.attachment_url}>

                        <button type="button" className="group-message-attach-btn">
                          Download Attachment
                        </button>
                      </a>}

                    <div className="group-message-stats">
                      <div className="group-message-stat">
                        <span className="group-message-stat-icon">
                          <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                        {`${selectedGroupMessageValue?.count_messages} Sent`}
                      </div>
                      <div className="group-message-stat">
                        <span className="group-message-stat-icon">
                          <FontAwesomeIcon icon={faEye} />
                        </span>
                        {`${selectedGroupMessageValue?.count_opened} viewed`}
                      </div>
                      <div className="group-message-stat">
                        <span className="group-message-stat-icon">
                          <FontAwesomeIcon icon={faReply} />
                        </span>
                        {`${selectedGroupMessageValue?.count_maybe} Didn't reply yet.`}
                      </div>
                    </div>
                  </> :

                <div className="group-message-detail-empty">
                    Select a group message to view details
                  </div>}

              </div>
            </div>
          </div>

          {openCreateGroupMessage &&
          <CreateMessage
            role="group"
            close={() => setOpenCreateGroupMessage(false)}
            openCannedModal={openCannedModal}
            setOpenedCannedModal={setOpenedCannedModal}
            message={messageValueForCreateMessage}
            setMessage={setMessageValueForCreateMessage}
            getMessageDetails={getGroupMessageDetails} />}



          {openCannedModal &&
          <CannedModal
            open={openCannedModal}
            close={() => setOpenedCannedModal(false)}
            handleCannedMessageSelect={(value) =>
            handleCannedMessageSelect(value)} />}



        </div>
      </div>
    </Fragment>);

};

export default GroupMessage;